import React from "react";
import { css } from "glamor";
import * as styles from "./section.style";
export default class Section extends React.Component {
  constructor(props) {
    super(props);
  }

  // Process HTML to wrap images with title/caption in styled containers
  processHTMLWithImageCaptions = (html) => {
    if (!html) return html;

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find all images
      const images = Array.from(doc.querySelectorAll("img"));

      if (images.length === 0) {
        // No images found, return original HTML
        return html;
      }

      images.forEach((img) => {
        // Extract all possible title/caption sources
        const dataTitle = img.getAttribute("data-title");
        const titleAttr = img.getAttribute("title");
        const dataCaption = img.getAttribute("data-caption");
        const altAttr = img.getAttribute("alt");
        let position = img.getAttribute("data-position");

        // Normalize position values: convert 'middle' to 'center', default to 'left'
        if (!position || position.trim() === "") {
          position = "left";
        } else {
          position = position.toLowerCase().trim();
          if (position === "middle") {
            position = "center";
          }
          // Validate position is one of: left, center, right
          if (!["left", "center", "right"].includes(position)) {
            position = "left";
          }
        }

        // Determine final title and caption
        const title = dataTitle || titleAttr || null;
        const caption = dataCaption || altAttr || null;

        // Wrap all images to ensure consistent alignment behavior
        if (true) {
          // Create wrapper container
          const wrapper = doc.createElement("div");
          wrapper.className = "image-with-caption-wrapper";

          // Preserve position for floating
          if (position) {
            wrapper.setAttribute("data-position", position);
          }

          // Add title on top (if exists)
          if (title) {
            const titleDiv = doc.createElement("div");
            titleDiv.className = "image-caption-title";
            titleDiv.textContent = title;
            wrapper.appendChild(titleDiv);
          }

          // Clone and add image
          const imgClone = img.cloneNode(true);
          imgClone.className = "image-with-caption-image";
          // Remove attributes that are now on wrapper
          imgClone.removeAttribute("data-title");
          imgClone.removeAttribute("data-caption");
          imgClone.removeAttribute("title");
          imgClone.removeAttribute("data-position");
          // Remove inline width/height so CSS controls sizing
          imgClone.removeAttribute("width");
          imgClone.removeAttribute("height");
          imgClone.style.width = "100%";
          imgClone.style.height = "auto";
          imgClone.style.display = "block";
          wrapper.appendChild(imgClone);

          // Add caption/source below image (if exists)
          if (caption) {
            const captionDiv = doc.createElement("div");
            captionDiv.className = "image-caption-text";
            captionDiv.textContent = caption;
            wrapper.appendChild(captionDiv);
          }

          // Replace original image with wrapper
          if (img.parentNode) {
            img.parentNode.replaceChild(wrapper, img);
          }
        }
      });

      return doc.body.innerHTML;
    } catch (error) {
      // Return original HTML if processing fails
      return html;
    }
  };

  render() {
    const processedSummary = this.processHTMLWithImageCaptions(
      this.props.summary,
    );

    return (
      <div {...css(styles.mainContainer)}>
        {/* Display the HTML content with processed image captions */}
        {processedSummary && (
          <div className="row">
            <div
              className="col-md-12 col-lg-12 col-sm-12 col-12"
              {...css(styles.padding0)}
            >
              <div
                className="summary-text"
                dangerouslySetInnerHTML={{ __html: processedSummary }}
                {...css(styles.summaryText)}
              ></div>
            </div>
          </div>
        )}

        {/* Display image prop if provided (separate from summary) */}
        {this.props.image && (
          <div className="row">
            <div
              className="col-md-12 col-lg-12 col-sm-12 col-12"
              {...css(styles.padding0)}
            >
              <img
                src={this.props.image}
                {...css(styles.image)}
                alt={"articleImage"}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
